export const inputClass =
    "w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-400 transition-colors focus:border-[#00B9EC] focus:outline-none focus:ring-1 focus:ring-[#00B9EC]";

export const primaryButton =
    "inline-flex w-full items-center justify-center rounded-xl bg-[#00B9EC] px-8 py-3.5 font-bold text-white transition hover:bg-[#00a3d1] disabled:cursor-not-allowed disabled:opacity-50";

export const dangerButton =
    "inline-flex w-full items-center justify-center rounded-xl bg-red-600 px-8 py-3.5 font-bold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50";

export const linkButton =
    "text-sm font-semibold text-[#00B9EC] hover:underline disabled:cursor-not-allowed disabled:text-gray-400 disabled:no-underline";

export const errorText = "mt-2 text-sm text-red-600";
